export default __webpack_public_path__ + "static/thumb-landscape-38e149dbd0055421b70c393a7e582527.jpg";